import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-4',
  templateUrl: './4.component.html',
  styleUrls: ['./4.component.scss'],
})
export class VbTablesBootstrap4Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
